import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import common from './assets/js/common'
import bhUi from './components/bh-ui'
import native from './assets/js/nativeApp'
import VueQriously from 'vue-qriously'
// import VueJsonp from 'vue-jsonp'
import { LoadMore } from 'muse-ui'
import Loading from 'muse-ui-loading'

import './assets/js/axios.config'
import './assets/css/common.less'
import 'muse-ui/lib/styles/base.less'
import 'muse-ui/lib/styles/theme.less'

// import store from './store'

Vue.use(common)
Vue.use(bhUi)
Vue.use(native)
Vue.use(LoadMore)
Vue.use(Loading)
Vue.use(VueQriously)
// Vue.use(VueJsonp)

Vue.prototype.$axios = axios

Vue.config.productionTip = false


new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')
